import React from "react";
import { FiChevronRight } from "react-icons/fi";
import { Booking } from "../../../../../logic/api";
import { useDate } from "../../../../../utility/useDate";
import { fullVehicleDescription, locationDescription, parseVehicleStatus } from '../condensedLayoutUtils';
import styles from "../styles";

const KeyRow: React.FunctionComponent<{
    booking: Booking,
    rowIndex: number,
    onClick: () => void
}> = (props) => {
    const { toFormattedFullDateTimeString } = useDate();
    const { booking, rowIndex } = props;
    const { ref, vehicleKey, vehicle, expectedReturnDate } = booking;
    const { statusId, registration } = vehicle;

    const rowStyles = {
        ...(rowIndex % 2 ? styles.tableRowOdd : styles.tableRowEven),
        cursor: "pointer",
    };

    return (<tr data-testid={`key-row-${booking.id}`} style={rowStyles} onClick={props.onClick}>
        <td style={styles.tableCell}>{parseVehicleStatus(statusId)}</td>
        <td style={styles.tableCell}>{ref}</td>
        <td style={styles.tableCell}>{locationDescription(vehicleKey.location)}</td>
        <td style={styles.tableCell}>{registration}</td>
        <td style={styles.tableCell}>{fullVehicleDescription(vehicle)}</td>
        <td style={styles.tableCell}>{toFormattedFullDateTimeString(new Date(expectedReturnDate))}</td>
        <td style={styles.tableCell}><FiChevronRight /></td>
    </tr>)
}

export default KeyRow;
